const server = process.env.REACT_APP_SERVER;

export async function createShareCode(userId, entryId, shareType) {
    try {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ userId, entryId, shareType })
        };
        const response = await fetch(`${server}/shareCode`, requestOptions);
        const result = await response.json();
        return result;
    }
    catch (e) {
        console.error(e, 'createShareCode');
    }
}

export async function updateShare(shareCode, propsToUpdate) {
    try {
        const requestOptions = {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ shareCode, ...propsToUpdate })
        };
        const response = await fetch(`${server}/shareCode`, requestOptions);
        const result = await response.json();
        return result;
    }
    catch (e) {
        console.error(e, 'updateShareExpiration');
    }
}

export async function getShareCodes(filterOptions) {
    try {
        const response = await fetch(`${server}/shareCodes?${new URLSearchParams(filterOptions)}`);
        const result = await response.json();
        return result;
    }
    catch (e) {
        console.error(e, 'getShareCodes');
    }
}

export async function deleteShareCodes(shareCodes) {
    try {
        const requestOptions = {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ shareCodes })
        };
        const response = await fetch(`${server}/shareCodes`, requestOptions);
        const result = await response.json();
        return result;
    }
    catch (e) {
        console.error(e, 'deleteShareCodes');
    }
}

export async function getSharedEntry(shareCode) {
    try {
        const requestParams = {
            share: shareCode
        };
        const response = await fetch(`${server}/sharedEntry?${new URLSearchParams(requestParams)}`);
        const result = await response.json();
        return result;
    }
    catch (e) {
        console.error(e, 'getSharedEntry');
    }
}